const ShopNickComponent = () => import('@/views/shop/ShopNick/ShopNickView')

export default [
    {
        path:'/ShopNickIndex',
        name:'ShopNickRouter',
        component:ShopNickComponent
    }
]